import React, { useRef, useState } from "react";
import Utils from "../../Utils";
import axios from "axios";
import validator from "validator";

const ChangePassword = () => {
  const frmRef = useRef(null);

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [processing, setProcessing] = useState(false);

  const getErrorMessage = (err) => {
    const message = err?.response?.data?.message || err?.message || err;

    if (typeof message === "string") {
      return message;
    }

    if (message && typeof message.message === "string") {
      return message.message;
    }

    return "Failed to change password";
  };

  const validatePassword = () => {
    const frm = frmRef.current;
    if (
      !validator.isStrongPassword(frm.newpwd.value, {
        minLength: 8,
        maxLength: 12,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      setError(
        "Password must be strong (8-12 chars, uppercase, number & symbol)",
      );
      return false;
    }

    if (frm.newpwd.value !== frm.confpwd.value) {
      setError("Passwords do not match");
      return false;
    }
    setError(false);
    return true;
  };

  const submitForm = (e) => {
    e.preventDefault();
    const frm = frmRef.current;

    if (!validatePassword()) return;

    setProcessing(true);
    setSuccess(false);

    const frmdata = new FormData(frm);

    axios
      .post(Utils.apiUrl("frontend/auth/chgpwd"), frmdata, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setSuccess(true);
          //Utils.setUserData(false);
          frm.reset();
        } else {
          throw res.data;
        }
      })
      .catch((err) => {
        setError(getErrorMessage(err));
      })
      .finally(() => setProcessing(false));
  };

  return (
    <main className="container mx-auto px-8 py-8">
      <h1 className="text-2xl font-bold mb-2 text-gray-800">
        Change your account password
      </h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600 mb-6">
          Please enter your current password and a new password below.
        </p>
        {/* Processing */}
        {processing && (
          <div className="bg-blue-100 text-blue-700 p-3 rounded mb-4">
            Processing password change...
          </div>
        )}

        {/* Success */}
        {success && (
          <div className="bg-green-100 text-green-700 p-3 rounded mb-4">
            Password updated successfully.
          </div>
        )}

        {/* Error */}
        {error && (
          <div className="bg-red-100 text-red-700 p-3 rounded mb-4">
            {error}
          </div>
        )}

        {!processing && (
          <form ref={frmRef} onSubmit={submitForm} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">
                Current Password
              </label>
              <input
                type="password"
                name="oldpwd"
                required
                className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                New Password
              </label>
              <input
                type="password"
                name="newpwd"
                onChange={validatePassword}
                required
                className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Confirm New Password
              </label>
              <input
                type="password"
                name="confpwd"
                onChange={validatePassword}
                required
                className="w-full px-3 py-2 border rounded focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="bg-gray-50 p-3 rounded text-sm text-gray-700">
              <ul>
                <li>• Minimum 8 - 12 characters</li>
                <li>• At least 1 uppercase letter</li>
                <li>• At least 1 lowercase letter</li>
                <li>• At least 1 digit</li>
                <li>• At least 1 special character (e.g., !@#$%^&*)</li>
              </ul>
            </div>

            <div className="text-right">
              <button
                type="submit"
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded font-medium"
              >
                Submit
              </button>
            </div>
          </form>
        )}
      </div>
    </main>
  );
};

export default ChangePassword;
